/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ param: NonNullable<unknown> }} Private_Models_Fact_ParamInputs */



/**
* | output |
* | --- |
* | "Parameter: {param}" |
*
* @param {Private_Models_Fact_ParamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_fact_param = /** @type {((inputs: Private_Models_Fact_ParamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Fact_ParamInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Parameter: ${i?.param}`)
	return /** @type {LocalizedString} */ (`Parameter: ${i?.param}`)
});